import React, { useState, useEffect } from 'react';
import review1 from '../../photos/review1.jpg';
import review2 from '../../photos/review2.jpg';
import review3 from '../../photos/review3.jpg';
import review4 from '../../photos/review4.jpg';
import review5 from '../../photos/review5.jpg';
import review6 from '../../photos/review6.jpg';
import review7 from '../../photos/review7.jpg';
import review8 from '../../photos/review8.jpg';
import review9 from '../../photos/review9.jpg';
import review10 from '../../photos/review10.jpg';
import review11 from '../../photos/review11.jpg';
import review12 from '../../photos/review12.jpg';
import review13 from '../../photos/review13.jpg';
import review14 from '../../photos/review14.jpg';
import review15 from '../../photos/review15.jpg';
import review16 from '../../photos/review16.jpg';
import review17 from '../../photos/review17.jpg';
import review18 from '../../photos/review18.jpg';
import review19 from '../../photos/review19.jpg';
import review20 from '../../photos/review20.jpg';

const reviews = [
  { title: "Дядченко Олександр", text: "Можу рекомендувати компанію як надійного перевізника. Подача авто оперативна, у випадку непередбачуваних негараздів все вирішується швидко та позитивно. Надійний партнер!", img: review5 },
  { title: "Поліщук Оксана Анатоліївна", text: "Дякую за багаторічну плідну співпрацю. Бажаю натхнення та кар'єрного зростання. Люблю всіх вас. Дуже вам дякую за красу, яку Ви даруєте.", img: review1 },
  { title: "Коваленко Дмитро", text: "Працюю з вами вже 9 років. Все чудово. Не проміняю вашу компанію ні на яку іншу", img: review2 },
  { title: "Вадим Ціпуринда", text: "Відколи почав працювати з найкращою логістичною компанією по перевезенню мінеральних добрив (з 2013 року) - все настільки ідеально, що жодного разу не було потреби звертатися за пошуком авто до іншої компанії. Порядні логісти, реальні ціни, оперативна доставка і найголовніше - надійність.", img: review3 },
  { title: "Мовчан Олександр Андрійович", text: "Надійна логістична компанія, працюємо разом вже понад 10 років, рекомендую.", img: review4 },
  { title: "Шутко Юрій", text: "12 років працюю з Горячою та її командою. Ще ні разу не підводили, машина знаходиться завжди. Дякую за співпрацю, далі більше!", img: review6 },
  { title: "Олена", text: "Рекомендуємо до роботи відповідального, надійного перевізника. Груз доставлений вчасно та в збереженні. Особлива подяка Михайлу за професійну роботу.", img: review7 },
  { title: "Олена", text: "Неодноразово співпрацювали. Відповідальний підхід, рекомендуємо до співпраці. Дякую", img: review8 },
  { title: "Ілля", text: "Налагоджено хорошу співпрацю, дуже відповідальні логісти. Дуже швидкий пошук автомобіля. Дякуємо, Алені за роботу справжнього професіонала! ТОВ АГРОНОМІЧНА КОМПАНІЯ", img: review9 },
  { title: "Струтинська Лілія", text: "Дуже дякую за співпрацю, за своєчасну допомогу, за щирі людяні відношення. Приємно працювати з Фахівцями своєї справи. Бажаю гарних клієнтів та успіхів. ТОВ Ванукрстрой", img: review10 },
  { title: "Задаєнна Вікторія", text: "Спасибі за оперативну і якісну роботу! Кращий підхід до клієнтів! Підбір надійних і перевірених перевізників, повний контроль перевезення, кращі ціни на ринку України! ТОВ 'Агро-Торговий Союз.Центр'", img: review11 },
  { title: "Лисенко Каріна", text: "Співпрацюємо вже не один рік. За цей час зарекомендували себе як надійний партнер та професійна команда. Висловлюю подяку та сподіваюся на подальшу плідну співпрацю. ТОВ 'САРС Агро'", img: review12 },
  { title: "Панчев Максим", text: "Можливо найкращі логісти України. Користуюся їхніми послугами дуже давно. Завжди швидко і оперативно. Дякую за професійний підхід до роботи. Тов ЦІІАТ", img: review13 },
  { title: "Анастасія", text: "З ФОП Горячий працюємо вже не перший рік. Надають нам транспортні послуги з перевезення добрив та КАСу. Завжди все чітко і з оформленням документів, і з строками доставки нашого вантажу. Менеджер завжди на зв'язку, ввічливі водії, які знають свою справу.", img: review14 },
  { title: "Полосмінкін Ігор", text: "Дякуємо за оперативну та якісну доставку вантажів. Бажаємо Вам успіхів і вдячних клієнтів. ТОВ 'Агроресурс-А'", img: review15 },
  { title: "Бишовець Сергій", text: "Дякую за якісно виконану роботу в сфері вантажоперевезень. Перевагами даної компанії є надійність, оперативність і комфорт. Вони надають клієнту повний спектр логістичних послуг. ПП Оптималбуд", img: review16 },
  { title: "Назаренко Яна", text: "Дякую за багаторічну плідну співпрацю. Завжди вчасно і без проблем. Логісти дуже ввічливі, завжди знаходять вихід! Бажаю кар'єрного зростання.", img: review17 },
  { title: "Корольова Ірина", text: "Рекомендуємо до співпраці! Всі питання вирішувались позитивно і оперативно. Бажаємо вашій компанії і всім працівникам розвитку і процвітання. ТОВ Фрея Трейд", img: review18 },
  { title: "Євген 'Українська Агропромислова група'", text: "Мені дуже приємно працювати з цією компанією. Хочу відзначити, що за час нашої співпраці співробітники компанії завжди працюють оперативно і якісно. Для них немає складнощів у перевезенні вантажів, завжди все на вищому рівні. Ви молодці, ви круті) Так тримати!!!", img: review19 },
  { title: "ТОВ 'Агро-Д.О.М.-Трейдінг' Дмитро", text: "За десять років роботи з компаніями по перевезенню вантажів, Я нарешті знайшов надійних партнерів і це команда The Hot Logistics. Дякую за надійність, швидкість. Команда The Hot Logistics це не тільки партнери, а й справжні друзі!!!!", img: review20 },
];

function Slider() {
  const [active, setActive] = useState(0);
  const touchStartX = React.useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setActive(prev => (prev + 1) % reviews.length);
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const isMobile = window.innerWidth <= 768;

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) setActive(prev => (prev + 1) % reviews.length);
      else setActive(prev => (prev - 1 + reviews.length) % reviews.length);
    }
    touchStartX.current = null;
  };

  const getVisible = () => {
    if (isMobile) {
      const idx = active % reviews.length;
      return [{ ...reviews[idx], offset: 0 }];
    }
    const result = [];
    for (let i = -1; i <= 1; i++) {
      const idx = (active + i + reviews.length) % reviews.length;
      result.push({ ...reviews[idx], offset: i });
    }
    return result;
  };

  return (
    <section style={{
      padding: 'clamp(60px, 8vw, 120px) 24px',
      background: '#0a0a0f',
      overflowX: 'hidden',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>Відгуки</span> клієнтів
        </h2>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Prev arrow */}
          <button
            onClick={() => setActive(prev => (prev - 1 + reviews.length) % reviews.length)}
            style={{
              flexShrink: 0,
              border: 'none',
              background: 'transparent',
              color: '#4dc247',
              fontSize: 32,
              cursor: 'pointer',
              padding: '0 8px',
              transition: 'all 0.2s ease',
              lineHeight: 1,
            }}
          >‹</button>

        <div
          onTouchStart={handleTouchStart}
          onTouchEnd={handleTouchEnd}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 24,
            minHeight: 320,
            position: 'relative',
            flex: 1,
            overflow: 'hidden',
          }}>
          {getVisible().map((review, i) => (
            <div key={`${review.title}-${review.offset}`} style={{
              flex: review.offset === 0 ? (isMobile ? '0 0 100%' : '0 0 450px') : '0 0 350px',
              maxWidth: review.offset === 0 ? (isMobile ? '100%' : 450) : 350,
              padding: 32,
              borderRadius: 20,
              background: review.offset === 0
                ? 'rgba(22,183,36,0.06)'
                : 'rgba(255,255,255,0.02)',
              border: `1px solid ${review.offset === 0
                ? 'rgba(22,183,36,0.2)'
                : 'rgba(255,255,255,0.05)'}`,
              opacity: review.offset === 0 ? 1 : 0.5,
              transform: `scale(${review.offset === 0 ? 1 : 0.9})`,
              transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              display: review.offset === 0 || window.innerWidth > 768 ? 'block' : 'none',
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
                <img src={review.img} alt="" style={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: review.offset === 0 ? '2px solid rgba(22,183,36,0.4)' : '2px solid rgba(255,255,255,0.1)',
                }} />
                <div style={{
                  color: '#fff',
                  fontWeight: 600,
                  fontSize: 16,
                }}>
                  {review.title}
                </div>
              </div>
              <p style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: 14,
                lineHeight: 1.7,
                fontStyle: 'italic',
              }}>
                "{review.text}"
              </p>
            </div>
          ))}
        </div>

          {/* Next arrow */}
          <button
            onClick={() => setActive(prev => (prev + 1) % reviews.length)}
            style={{
              flexShrink: 0,
              border: 'none',
              background: 'transparent',
              color: '#4dc247',
              fontSize: 32,
              cursor: 'pointer',
              padding: '0 8px',
              transition: 'all 0.2s ease',
              lineHeight: 1,
            }}
          >›</button>
        </div>

        {/* Dots */}
        <div style={{ display: 'flex', gap: '8px', marginTop: 32, flexWrap: 'wrap', justifyContent: 'center' }}>
          {reviews.map((_, i) => (
              <button
                key={i}
                onClick={() => setActive(i)}
                style={{
                  width: i === active ? 28 : 10,
                  height: 10,
                  borderRadius: 5,
                  border: 'none',
                  cursor: 'pointer',
                  background: i === active
                    ? 'linear-gradient(135deg, #16b724, #4dc247)'
                    : 'rgba(255,255,255,0.15)',
                  transition: 'all 0.3s ease',
                }}
              />
            ))}
        </div>
      </div>
    </section>
  );
}

export default Slider;
